<template>
    <div class="propertyTemplate">
<!--        <el-card>-->
<!--            <el-page-header v-if="from == 'agreement'" @back="goBack" content="协议价格列表"></el-page-header>-->
<!--            <el-breadcrumb v-if="from == 'menu'" separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>协议管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>协议价格录入</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                 <el-table
                    :data="tableData"
                    v-loading="loading"
                    style="width: 100%">
                    <el-table-column
                        prop="sku"
                        label="商品编码"
                       >
                    </el-table-column>
                    <el-table-column
                        prop="materialNumber"
                        label="物料号"
                       >
                    </el-table-column>
                    <el-table-column
                        prop="productName"
                        label="商品名称"
                       >
                    </el-table-column>
                    <el-table-column
                        prop="untaxedPrice"
                        label="协议价格(未税)"
                        :formatter="priceFormatter">
                    </el-table-column>
                    <el-table-column
                        prop="price"
                        label="协议价格(含税)"
                        :formatter="priceFormatter">
                    </el-table-column>
                    <el-table-column label="操作" width="350" align="right">
                        <template slot="header">
                            <a href="/template/agreement_detail.xlsx" style="margin-right:16px">下载模板</a>
                            <el-button type="primary" size="mini" @click="() => uploadDialogVisible = true" v-if="action == 'edit'">导入</el-button>
                            <el-button type="primary" size="mini" @click="handleExport">导出</el-button>
                            <el-button type="primary" size="mini" @click="handleCreate" v-if="action == 'edit'">添加</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)" v-if="action == 'edit'">编辑信息</el-button>
                            <el-button
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)" v-if="action == 'edit'">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="协议商品信息" :visible.sync="editDialogVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px">
                <el-form-item label="物料号" prop="materialNumber">
                    <el-input v-model="editForm.materialNumber" placeholder="请输入物料号" clearable></el-input>
                </el-form-item>
                <el-form-item label="未税价格" prop="untaxedPrice">
                    <el-input v-model="editForm.untaxedPrice" placeholder="请输入商品未税价格" clearable></el-input>
                </el-form-item>
                <el-form-item label="含税价格" prop="price">
                    <el-input v-model="editForm.price" placeholder="请输入商品含税价格" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="导入协议价格" :modal="true" :visible.sync="uploadDialogVisible" width="560px">
            <el-upload ref="upload"
                class="upload-demo"
                drag
                :action="'/api/admin/agreement/uploadDetail/' + agreementId"
                :http-request="uploadDetailRequest"
                :limit="1"
                accept=".xlsx"
                :show-file-list="true">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip" style="color:red;line-height:1.6">
                    注意：全部成功时会替换本协议下的原有协议价格；任一行失败则整单不落库。<br>
                    模板只需三列（物料号、未税、含税）；上传后会下载结果 Excel，请查看「导入结果」「失败原因」列。
                </div>
            </el-upload>
            <div v-html="uploadCheckResult" style="color:#F56C6C;margin-top:12px;line-height:1.6;word-break:break-all;"></div>
        </el-dialog>
    </div>
</template>
<script>
import { convertRes2Blob } from '@/utils/download';

export default {
    data() {
        return {
            searchForm: {
                itemId: "",
                itemName: "",
                itemPrice: "",
                buyerCode: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            uploadDialogVisible: false,
            editForm: {
                id: "",
                agreementId: "",
                sku: "",
                materialNumber: "",
                untaxedPrice: "",
                price: "",
            },
            uploadCheckResult: "",
            from: "",
            agreementId: "",
            action: "",
            rules: {
                materialNumber: [
                    { required: true, message: '请输入物料号', trigger: 'blur' }
                ],
                untaxedPrice: [
                    { required: true, message: '请输入未税协议价格', trigger: 'blur' },
                    { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额', trigger: 'blur' }
                ],
                price: [
                    { required: true, message: '请选择含税协议价格', trigger: 'blur' },
                    { pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的金额', trigger: 'blur' }
                ],
            },
        }
    },
    methods: {
        onSearch() {
            this.loading = true;
            let _this = this
            this.$axios.post("/admin/agreement/agreementDetail/search",{
                cond: {agreementId: this.agreementId},
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            });
        },
        handleCreate() {
            this.editForm.agreementId= this.agreementId;
            this.editForm.sku = "";
            this.editForm.materialNumber = "";
            this.editForm.untaxedPrice = "";
            this.editForm.price = "";
            this.editDialogVisible = true;
        },
        handleCreateImport() {
            this.editForm.agreementId= this.agreementId;
            this.importDialogVisible = true;
        },
        handleExport() {
            let url = "/api/admin/agreement/exportDetail/"+this.agreementId;
            window.open(url, "_blank");
        },
        onSubmit() {
            let that = this;
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    this.$axios.post("/admin/agreement/saveDetail", this.editForm)
                    .then(function(response){
                        let resp = response.data;
                        if(resp.header.status == 0) {
                            that.$notify({
                                title: '成功',
                                message: '数据保存成功',
                                type: 'success'
                            });
                            that.editDialogVisible = false;
                            that.onSearch();
                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
                }
            });
        },
        uploadDetailRequest({ file }) {
            this.uploadCheckResult = '';
            const formData = new FormData();
            formData.append('file', file);
            this.$axios.post('/admin/agreement/uploadDetail/' + this.agreementId, formData, {
                responseType: 'blob',
                headers: { 'Content-Type': 'multipart/form-data' },
                timeout: 600000
            }).then(async (response) => {
                this.$refs.upload && this.$refs.upload.clearFiles();
                const contentType = (response.headers['content-type'] || '').toLowerCase();
                // 仅系统级/业务硬失败可能返回 JSON；预检与导入结果统一为 Excel
                if (contentType.includes('application/json')) {
                    const text = await response.data.text();
                    let msg = '上传失败';
                    try {
                        const json = JSON.parse(text);
                        msg = (json.header && (json.header.msg || json.header.msg_cd)) || msg;
                    } catch (e) {
                        msg = text || msg;
                    }
                    this.uploadCheckResult = msg;
                    this.$notify({
                        title: '上传失败',
                        message: String(msg).replace(/<br\s*\/?>/gi, '；'),
                        type: 'error',
                        duration: 8000
                    });
                    return;
                }
                convertRes2Blob(response);
                this.$notify({
                    title: '完成',
                    message: '已下载结果 Excel，请查看「导入结果」「失败原因」列',
                    type: 'success',
                    duration: 5000
                });
                this.uploadDialogVisible = false;
                this.onSearch();
            }).catch(async (err) => {
                this.$refs.upload && this.$refs.upload.clearFiles();
                let msg = '上传失败';
                try {
                    const data = err.response && err.response.data;
                    if (data instanceof Blob) {
                        const text = await data.text();
                        try {
                            const json = JSON.parse(text);
                            msg = (json.header && (json.header.msg || json.header.msg_cd)) || text;
                        } catch (e) {
                            msg = text || msg;
                        }
                    } else if (err.message) {
                        msg = err.message;
                    }
                } catch (e) {
                    // ignore
                }
                this.uploadCheckResult = msg;
                this.$notify({
                    title: '上传失败',
                    message: String(msg).replace(/<br\s*\/?>/gi, '；'),
                    type: 'error',
                    duration: 8000
                });
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEdit(index, row) {
            this.editForm.id = row.id;
            this.editForm.agreementId = this.agreementId;
            this.editForm.materialNumber = row.materialNumber;
            this.editForm.untaxedPrice = row.untaxedPrice;
            this.editForm.price = row.price;
            this.editDialogVisible = true;
        },

        handleDelete(index, row) {
            let _this = this;
            this.$confirm('是否删除商品编号【' + row.sku + '】的协议价格？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.get("/admin/agreement/agreementdetail/delete/" + row.id)
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status === 0) {
                        _this.$notify({
                            title: '成功',
                            message: '数据删除成功',
                            type: 'success'
                        });
                        _this.onSearch();
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            })
        },
        // 文件状态改变时的钩子
        fileChange(file) {
            this.editForm.file = file.raw
        },
        // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
        beforeUploadFile(file) {
            let extension = file.name.substring(file.name.lastIndexOf('.')+1)
            let size = file.size / 1024 / 1024
            if(extension !== 'xlsx') {
                this.$notify.warning({
                    title: '警告',
                    message: `只能上传Excel2017（即后缀是.xlsx）的文件`
                });
            }
            if(size > 10) {
                this.$notify.warning({
                    title: '警告',
                    message: `文件大小不得超过10M`
                });
            }
        },
        // 文件上传成功时的钩子
        handleSuccess(res, file) {
            this.$notify.success({
                title: '成功',
                message: `文件上传成功`
            });
            if (file.response.data.success) {
                this.editForm.filePath = file.response.data.message; //将返回的文件储存路径赋值picture字段
            }
        },
        // 文件上传失败时的钩子
        handleError() {
            this.$notify.error({
                title: '错误',
                message: `文件上传失败`
            });
        },
        goBack() {
            this.$router.go(-1);

        },
        priceFormatter(row, column, cellValue) {
            return "￥" + cellValue + "元";
        },
    },
    created() {
        let paramsStore;
        const params = sessionStorage.getItem("params");
        if(params) {
            paramsStore = JSON.parse(params);
        }
        const { from, agreementId, action } = JSON.stringify(this.$route.params)== "{}"?paramsStore:this.$route.params;

        this.from = from;
        this.agreementId = agreementId;
        this.action = action;
        this.onSearch();
        // console.log(this.$route.query);
    },
}
</script>
<style>

</style>